// From this zoom up the map asks for the parkings' entrances and borders and draws them instead of their pins.
export const PARKING_SHAPES_MIN_ZOOM = 16;

// Google Maps takes raw colors, not CSS variables: `--color-brand` and `--color-brand-2` of the light theme.
export const PARKING_SHAPE_COLOR = '#023cbb';
export const PARKING_SHAPE_SELECTED_COLOR = '#ffa800';
